import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import technical from '../../assets/image/digital-learning/technical.jpg'

export default class game extends Component {
    render() {
        const image=[
            {image:technical}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Digital Learning','Techniccal Inhouse Workshop']} image={image} title="Technical In&#8209;house Workshops for E&#8209;Learning Administrator" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                We share our knowledge and years of experiences as an <span>e&#8209;learning</span> implementor and practices in various industry and corporate. We will prepare your administrator and content contributor team to be capable in maintaining and optimizing the utilization of your digital learning platform.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
